import http from './httpService';

export async function getStock(request) {
	return await http.post(`/Stock`, request);
}

export default { getStock };
